import { mapEventsDigitalToSTCharTimeLine } from './util/mapEventsDigitalToSTCharTimeLine';
import { STTimeLineChartData } from '../../components/GroupManager/components/Devices/components/Monitoring/monitoring.model';
import { ServiceBase } from '../ServiceBase.model';
import { mapSensordataToSTChartLine } from './util/mapSensordataToSTChartLine';
import { SensordataSTChartLine, UUID } from './monitoring.model';
import { MonitoringCalls } from './MonitoringCalls';
import { getTranslateManyDevicesFunction } from '../../util/CUTranslation/getTranslateFunction';
import { CommanderControlUnitChannelFilterLogicalObject } from '../../components/GroupManager/components/Devices/components/Monitoring/util/filter.model';
import { ShowLevelOption } from '../../redux/groups/selectors/getLevelOfView';
import { ControlUnitState } from '../../redux/controlUnit/slice/controlUnitSlice';

/**
 * Service class:
 * this class get the data from the backend for frontend service and use
 * the corresponding class (Group, Device, User, Right) to transform it
 */
export class MonitoringService extends ServiceBase {
  constructor(private monitoringCalls = new MonitoringCalls()) {
    super();
  }
  /**
   * @param deviceId {string} id of device
   * @param start {new Date().getTime()} Milliseconds of the date where you want to start searching
   * @param end {new Date().getTime()} Milliseconds of the date where you want to finish searching
   * @returns Dictionary of Sensordata from this device in the datetime range used
   */
  getSensordata(
    deviceId: string,
    start: number,
    end: number,
    deviceName: string,
    commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject,
    CUsTranslate: ReturnType<typeof getTranslateManyDevicesFunction>,
    showLevelOption: ShowLevelOption
  ): Promise<Record<UUID, SensordataSTChartLine[]>> {
    return Promise.all(
      Object.entries(commanderFilterObject).map(
        ([keyControlUnit, valueObject]) => {
          return this.monitoringCalls.getSensordataByDeviceID(
            deviceId,
            start,
            end,
            {
              [keyControlUnit]: valueObject,
            }
          );
        }
      )
    )
      .then((data) => data.flat())
      .then((data) => ({
        [deviceId]: data.map((sensorData) =>
          mapSensordataToSTChartLine(
            sensorData,
            deviceId,
            deviceName,
            CUsTranslate,
            showLevelOption
          )
        ),
      }));
  }

  /**
   * @param deviceId {string} id of device
   * @param start {new Date().getTime()} Milliseconds of the date where you want to start searching
   * @param end {new Date().getTime()} Milliseconds of the date where you want to finish searching
   * @returns Dictionary of Sensordata from this device in the datetime range used
   */
  getDigitalChannels(
    deviceId: string,
    start: number,
    end: number,
    deviceName: string,
    commanderFilterObject: CommanderControlUnitChannelFilterLogicalObject,
    CUsTranslate: ReturnType<typeof getTranslateManyDevicesFunction>,
    showLevelOption: ShowLevelOption,
    controlUnitState: ControlUnitState
  ): Promise<Record<UUID, STTimeLineChartData>> {
    // return Promise.resolve(mockDigital(deviceID + '', start, end));
    return Promise.all(
      Object.entries(commanderFilterObject).map(
        ([keyControlUnit, valueObject]) => {
          return this.monitoringCalls.getEventsByID(deviceId, start, end, {
            [keyControlUnit]: valueObject,
          });
        }
      )
    )
      .then((data) => data.flat())
      .then((data) => ({
        [deviceId]: mapEventsDigitalToSTCharTimeLine(
          data.map((item) => ({
            ...item,
            deviceId: deviceId,
            deviceName: deviceName,
            events: item.events.map((event) => ({
              ...event,
              timestamp: Math.floor(event.timestamp / 1000),
            })),
          })),
          Math.floor(start / 1000),
          Math.floor(end / 1000),
          CUsTranslate,
          showLevelOption,
          controlUnitState
        ),
      }));
  }
}
